export const IMAGE_PLACEHOLDER = '/images/placeholders/image.jpg';
